"use strict";

module.exports = {
    extend: function extend() {
        for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
            params[_key] = arguments[_key];
        }

        var obj = {};

        var _loop = function _loop(i) {
            Object.keys(params[i]).forEach(function (key) {
                if (params[i].hasOwnProperty(key)) {
                    obj[key] = params[i][key];
                }
            });
        };

        for (var i = 0; i < params.length; i++) {
            _loop(i);
        }
        return obj;
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/~/@souche-f2e/tower/lib/lib/common.js
// module id = 186
// module chunks = 4